export default {
  timezones: 'timezones',
  languages: 'languages',
} as const;
